import * as React from "react";

const EmailIllustration = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" >
    <ellipse
      cx={250}
      cy={345.8}
      rx={223.4}
      ry={131.22}
      style={{
        fill: "#f5f5f5",
      }}
    />
    <path
      d="M94 345.91c12.92 7.46 12.92 19.56 0 27s-33.89 7.46-46.82 0-12.93-19.57 0-27 33.82-7.47 46.82 0ZM122.34 363.06l117.26 67.7a9.57 9.57 0 0 0 8.66 0l198.5-114.6c2.39-1.38 2.39-3.62 0-5L329.5 243.45a9.57 9.57 0 0 0-8.66 0l-198.5 114.61c-2.4 1.38-2.4 3.62 0 5Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="m418.28 291.88-8.17-4.72s-4.87-20.21-2.93-38.39c2.73-25.56 16.48-36.69 25.95-33 6.3 2.48 8.25 9.64-2.34 24.87-6.24 9.01-13.91 27.71-12.51 51.24Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m418.28 291.88-8.17-4.72s-4.87-20.21-2.93-38.39c2.73-25.56 16.48-36.69 25.95-33 6.3 2.48 8.25 9.64-2.34 24.87-6.24 9.01-13.91 27.71-12.51 51.24Z"
      style={{
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="M414.89 282h.11a.56.56 0 0 0 .45-.66c-4.48-23.57 3.76-50.07 14-61.09a.57.57 0 0 0-.84-.77c-10.38 11.23-18.78 38.15-14.23 62.07a.55.55 0 0 0 .51.45Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M439.68 304.24c1.29.65 4.72-2.29 5.68-3a12 12 0 0 0 3.75-4.77 11.27 11.27 0 0 0 .65-6.79 26.43 26.43 0 0 0-1-3.54l-1.17-3.42a8.82 8.82 0 0 1-.69-3.48c.18-2.4 2.21-4.17 4.06-5.7 2-1.7 4.14-3.91 4-6.77a10.09 10.09 0 0 0-2.83-5.87c-1.45-1.66-3.16-3.11-4.49-4.88a7.05 7.05 0 0 1-1.66-4.38 7.33 7.33 0 0 1 .83-2.83 39.57 39.57 0 0 0 2.76-5.72c.6-2 .37-4.53-1.26-5.88-1.35-1.11-3.26-1.18-5-1a11.36 11.36 0 0 0-4.5 1.84c-4.42 2.76-6.74 8.28-11.47 10.46a49 49 0 0 1-5.76 1.73c-1.92.61-3.85 1.7-4.65 3.53-1.6 3.63 1.91 7.82.85 11.64-.93 3.38-4.09 4.81-5.75 7.9a7 7 0 0 0-.63 4.39 20.79 20.79 0 0 0 2.2 7.25 63.71 63.71 0 0 0 4.37 6.71s21.51 12.48 21.71 12.58Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M439.68 304.24c1.29.65 4.72-2.29 5.68-3a12 12 0 0 0 3.75-4.77 11.27 11.27 0 0 0 .65-6.79 26.43 26.43 0 0 0-1-3.54l-1.17-3.42a8.82 8.82 0 0 1-.69-3.48c.18-2.4 2.21-4.17 4.06-5.7 2-1.7 4.14-3.91 4-6.77a10.09 10.09 0 0 0-2.83-5.87c-1.45-1.66-3.16-3.11-4.49-4.88a7.05 7.05 0 0 1-1.66-4.38 7.33 7.33 0 0 1 .83-2.83 39.57 39.57 0 0 0 2.76-5.72c.6-2 .37-4.53-1.26-5.88-1.35-1.11-3.26-1.18-5-1a11.36 11.36 0 0 0-4.5 1.84c-4.42 2.76-6.74 8.28-11.47 10.46a49 49 0 0 1-5.76 1.73c-1.92.61-3.85 1.7-4.65 3.53-1.6 3.63 1.91 7.82.85 11.64-.93 3.38-4.09 4.81-5.75 7.9a7 7 0 0 0-.63 4.39 20.79 20.79 0 0 0 2.2 7.25 63.71 63.71 0 0 0 4.37 6.71s21.51 12.48 21.71 12.58Z"
      style={{
        opacity: 0.15,
      }}
    />
    <path
      d="M427.17 297.72a.57.57 0 0 0 .52-.62c-2.07-22.42 7.27-47.76 14.6-55.36a.57.57 0 1 0-.81-.79c-7.49 7.75-17 33.52-14.92 56.25a.57.57 0 0 0 .61.52Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M429.4 270.07h.17a75.12 75.12 0 0 1 16.17-3.45.57.57 0 0 0 .51-.62.54.54 0 0 0-.61-.51 77.61 77.61 0 0 0-16.46 3.51.57.57 0 0 0 .22 1.1Z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M126.34 350.62a10.61 10.61 0 0 0 4.95 8.21L239 421a11 11 0 0 0 9.89 0L438.5 311.53a9.28 9.28 0 0 0 0-16.42l-107.69-62.19a10.91 10.91 0 0 0-9.89 0L131.29 342.4a10.63 10.63 0 0 0-4.95 8.22Z"
      style={{
        fill: "#37474f",
      }}
    />
    <path
      d="M131.29 348.11 239 410.3a10.91 10.91 0 0 0 9.89 0L438.5 300.82c2.74-1.58 2.74-4.14 0-5.71l-107.69-62.19a10.91 10.91 0 0 0-9.89 0L131.29 342.4c-2.73 1.6-2.73 4.14 0 5.71Z"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="M243.93 411.49v10.71a10.09 10.09 0 0 1-5-1.18l-107.64-62.19a9.26 9.26 0 0 1-.5-16.11c-2.22 1.59-2 3.92.5 5.4L239 410.31a10.2 10.2 0 0 0 4.93 1.18Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M121.7 342.58c-2.56-1.48-2.42-4-2.42-7.13V186.7a11 11 0 0 1 5-8.57L313.86 68.65a10.61 10.61 0 0 1 9.58-.18c2.57 1.48 2.43 4 2.43 7.14v148.74a10.94 10.94 0 0 1-4.95 8.57L131.29 342.4a10.6 10.6 0 0 1-9.59.18Z"
      style={{
        fill: "#37474f",
      }}
    />
    <path
      d="M325.87 75.6c0-3.15-2.22-4.42-4.95-2.85L131.29 182.24a10 10 0 0 0-3.5 3.69l-7.05-4.1a10.08 10.08 0 0 1 3.5-3.7L313.85 68.65a10.6 10.6 0 0 1 9.59-.18c2.56 1.53 2.43 3.98 2.43 7.13Z"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="M130.71 342.7a10.63 10.63 0 0 1-9-.12c-2.56-1.48-2.43-4-2.43-7.13V186.7a10 10 0 0 1 1.45-4.87l7.06 4.09a10.14 10.14 0 0 0-1.45 4.87v148.76c0 2.92 1.91 4.24 4.37 3.15Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="M134 187.94 316.78 82.41c1.64-1 3-.18 3 1.71V214a6.55 6.55 0 0 1-3 5.14L134 324.64c-1.64.94-3 .18-3-1.72V193.08a6.57 6.57 0 0 1 3-5.14Z"
      style={{
        fill: "#fafafa",
      }}
    />
    <path
      d="m145 342.7 176-101.63a5.44 5.44 0 0 1 4.94 0l2.93 1.61c1.37.79 1.37 2.07 0 2.86l-176 101.6a5.47 5.47 0 0 1-5 0l-2.9-1.59c-1.36-.79-1.36-2.07.03-2.85ZM158.78 350.9l176-101.62a5.05 5.05 0 0 1 4.52-.25l45.81 26.46c1.13.65.94 1.82-.42 2.61L208.9 379.58a5.11 5.11 0 0 1-4.53.26l-46-26.33c-1.14-.65-.95-1.82.41-2.61Z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="m311.3 292 5.52-3.18c.23-.13.25-.34 0-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.51 3.19c-.24.13-.26.34 0 .46l5.27 3a.87.87 0 0 0 .79-.01Zm-8-11-5.51 3.18c-.24.13-.26.34-.05.46l5.27 3a.9.9 0 0 0 .8 0l5.51-3.19c.24-.13.26-.34.05-.46l-5.27-3a.87.87 0 0 0-.84.01Zm-17.81 10.28-9.32 5.38c-.24.13-.26.34-.05.46l5.27 3.05a.9.9 0 0 0 .8 0l9.33-5.39c.23-.13.25-.34 0-.46l-5.28-3a.87.87 0 0 0-.79-.08Zm9.75-5.63-5.51 3.18c-.23.13-.25.34-.05.46l5.28 3a.9.9 0 0 0 .8 0l5.51-3.19c.23-.13.25-.34 0-.46l-5.28-3a.87.87 0 0 0-.79-.03Zm-21.62 12.48-5.51 3.18c-.23.14-.25.34-.05.46l5.28 3a.91.91 0 0 0 .8 0l5.51-3.18c.23-.14.25-.34.05-.47l-5.28-3a.87.87 0 0 0-.84-.03Zm-8.05 4.65-5.57 3.14c-.24.14-.26.34 0 .46l5.27 3.05a.9.9 0 0 0 .8 0l5.51-3.18c.24-.14.26-.34.05-.47l-5.27-3a.87.87 0 0 0-.83-.04Zm20.66 12.42 5.52-3.18c.23-.14.25-.34 0-.46l-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.34-.05.46l5.27 3.05a.9.9 0 0 0 .8-.09Zm-8.05 4.65 5.51-3.18c.23-.14.26-.34.05-.46l-5.27-3.05a.89.89 0 0 0-.81 0l-5.51 3.18c-.23.14-.25.34 0 .46l5.27 3a.9.9 0 0 0 .72.01Zm-8.06 4.65 5.52-3.18c.23-.14.25-.34 0-.46l-5.27-3.05a.87.87 0 0 0-.8 0l-5.51 3.19c-.24.14-.26.34-.05.46l5.27 3.05a.87.87 0 0 0 .8-.05Zm-8.12 4.61 5.51-3.18c.24-.14.26-.34 0-.46l-5.27-3.05a.87.87 0 0 0-.8 0l-5.44 3.21c-.23.14-.25.34 0 .46l5.27 3.05a.87.87 0 0 0 .73-.03Zm41.22-32.5 5.51-3.18c.23-.13.26-.34.05-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.52 3.19c-.23.13-.25.34 0 .46l5.27 3a.87.87 0 0 0 .79-.01Zm-9 13.9 12.29-7.1c.24-.13.26-.34 0-.46l-12.8-7.39a.92.92 0 0 0-.81 0l-6.35 3.67c-.24.14-.26.35-.05.47l6.78 3.91c.21.12.18.33-.05.46l-5.01 2.93c-.23.14-.25.34 0 .46l5.27 3.05a.9.9 0 0 0 .76 0Zm-36.78-3.12-5.44 3.18c-.23.14-.25.34 0 .46l5.27 3.05a.9.9 0 0 0 .8 0l5.51-3.18c.23-.14.25-.34.05-.46l-5.28-3.05a.87.87 0 0 0-.88 0Zm-8.02 4.61-5.51 3.18c-.24.14-.26.34 0 .46l5.27 3.05a.87.87 0 0 0 .8 0l5.51-3.18c.24-.14.26-.34.05-.46l-5.32-3.05a.87.87 0 0 0-.8 0Zm-44.57 49.65a.87.87 0 0 0 .8 0l5.51-3.18c.23-.13.25-.34.05-.46l-5.28-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.35-.05.47ZM185 349.24l-5.51 3.18c-.23.14-.26.35-.05.47l5.28 3a.87.87 0 0 0 .8 0l5.51-3.18c.23-.13.25-.34 0-.46l-5.27-3a.87.87 0 0 0-.76-.01Zm10.21 9.33a.93.93 0 0 0 .81 0l5.51-3.18c.23-.14.25-.35 0-.47l-5.27-3a.87.87 0 0 0-.8 0l-5.46 3.14c-.23.13-.26.34-.05.46Zm22.23 5 5.51-3.18c.23-.13.25-.34 0-.46l-5.28-3a.9.9 0 0 0-.8 0l-5.51 3.19c-.23.13-.25.34 0 .46l5.27 3a.87.87 0 0 0 .79-.02Zm-8.86 4.68a.87.87 0 0 0 .8 0l5.51-3.18c.24-.13.26-.34 0-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.51 3.19c-.24.13-.26.34-.05.46ZM193 344.59l-5.52 3.18c-.23.14-.25.35 0 .47l5.27 3a.87.87 0 0 0 .8 0l5.51-3.18c.24-.13.26-.34.05-.46l-5.27-3.05a.9.9 0 0 0-.84.04Zm40.27-23.25-5.51 3.18c-.24.14-.26.34-.05.46l5.27 3a.87.87 0 0 0 .8 0l5.52-3.18c.23-.14.25-.34 0-.46l-5.27-3.05a.87.87 0 0 0-.72.05Zm-32.22 18.6-5.51 3.18c-.23.14-.26.35-.05.47l5.27 3a.89.89 0 0 0 .81 0l5.51-3.18c.23-.14.25-.34 0-.46l-5.27-3a.9.9 0 0 0-.72-.01Zm40.27-23.25-5.51 3.18c-.23.14-.25.34 0 .46l5.27 3.05a.87.87 0 0 0 .8 0l5.51-3.18c.23-.14.25-.34.05-.46l-5.28-3a.87.87 0 0 0-.8-.05ZM225.25 326l-5.51 3.18c-.23.14-.25.34 0 .46l5.27 3.05a.87.87 0 0 0 .8 0l5.51-3.18c.23-.14.26-.34.05-.46l-5.31-3.05a.89.89 0 0 0-.81 0Zm-8.05 4.65-5.51 3.18c-.24.14-.26.34-.05.46l5.27 3.05a.87.87 0 0 0 .8 0l5.52-3.18c.23-.14.25-.34 0-.46l-5.23-3.09a.9.9 0 0 0-.8.03Zm-8 4.65-5.52 3.18c-.23.14-.25.35 0 .47l5.27 3a.87.87 0 0 0 .8 0l5.51-3.18c.24-.14.26-.34.05-.46l-5.31-3.05a.9.9 0 0 0-.85.03Zm36.77 3.12 5.51-3.18c.24-.14.26-.34 0-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.52 3.18c-.23.14-.25.34 0 .46l5.27 3.05a.87.87 0 0 0 .76-.06Zm75.14-67.73-5.51 3.18c-.23.13-.25.34-.05.46l5.28 3a.9.9 0 0 0 .8 0l5.51-3.19c.23-.13.25-.34.05-.46l-5.28-3a.87.87 0 0 0-.85 0Zm-9.75 5.62-5.51 3.19c-.23.13-.25.34-.05.46l5.28 3a.9.9 0 0 0 .8 0l5.51-3.19c.23-.13.25-.34.05-.46l-5.28-3a.9.9 0 0 0-.85-.01ZM329.12 266l-5.51 3.18c-.24.13-.26.34-.05.46l5.27 3a.9.9 0 0 0 .8 0l5.51-3.19c.24-.13.26-.34.05-.46l-5.27-3a.87.87 0 0 0-.8.01Zm-44.52 41.38 5.51-3.18c.23-.13.25-.34.05-.46l-5.28-3a.9.9 0 0 0-.8 0l-5.51 3.19c-.23.13-.25.34-.05.46l5.28 3a.87.87 0 0 0 .8-.01Zm53.37-46a.9.9 0 0 0-.8 0l-5.51 3.19c-.23.13-.25.34-.05.46l5.28 3a.9.9 0 0 0 .8 0l5.51-3.19c.23-.13.25-.34.05-.46Zm-84 72.41 5.51-3.18c.23-.14.25-.34 0-.46l-5.27-3.05a.87.87 0 0 0-.8 0l-5.41 3.18c-.23.14-.26.34 0 .46l5.27 3.05a.89.89 0 0 0 .73-.03Zm98.77-57 5.51-3.18c.24-.13.26-.34.05-.46L353 270a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35-.05.47l5.27 3a.87.87 0 0 0 .84.08Zm-15.59.3 5.52-3.18c.23-.13.25-.34 0-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.51 3.19c-.24.13-.26.34-.05.46l5.27 3a.87.87 0 0 0 .85-.1Zm8.34-11.33a.9.9 0 0 0-.8 0l-5.51 3.19c-.23.13-.25.34 0 .46l5.27 3a.87.87 0 0 0 .8 0l5.51-3.18c.23-.13.26-.34 0-.46Zm1.7-1 12.8 7.39a.89.89 0 0 0 .81 0l5.51-3.18c.23-.13.25-.34 0-.46l-12.8-7.39a.9.9 0 0 0-.8 0l-5.51 3.18c-.2.09-.2.3 0 .42ZM328.59 275l-5.51 3.19c-.23.13-.25.34 0 .46l5.27 3a.87.87 0 0 0 .8 0l5.51-3.18c.23-.13.26-.34.05-.46l-5.27-3a.92.92 0 0 0-.85-.01ZM268 310l-5.51 3.19c-.23.13-.25.34 0 .46l5.28 3a.87.87 0 0 0 .8 0l5.43-3.15c.23-.13.25-.34.05-.46l-5.28-3a.9.9 0 0 0-.77-.04Zm75.93-28.61a.87.87 0 0 0 .8 0l5.51-3.18c.23-.13.25-.34 0-.46l-5.24-3.06a.9.9 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.35-.05.47Zm-67.87 24-5.51 3.19c-.24.13-.26.34 0 .46l5.27 3a.87.87 0 0 0 .8 0l5.51-3.18c.24-.13.26-.34.05-.46l-5.27-3a.9.9 0 0 0-.91-.03ZM212.9 357a.87.87 0 0 0 .8 0l5.51-3.18c.24-.13.26-.34 0-.46l-5.21-3.04a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35-.05.47Zm-9.36-9.81-5.54 3.22c-.23.13-.25.34 0 .46l5.27 3a.87.87 0 0 0 .8 0l5.51-3.18c.24-.14.26-.35.05-.47l-5.27-3a.87.87 0 0 0-.82.01Zm18.22 5.13 5.51-3.18c.23-.13.25-.34 0-.46l-5.27-3.01a.9.9 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.35 0 .47l5.28 3a.87.87 0 0 0 .79.04Zm8.05-4.65 5.51-3.18c.24-.14.26-.34.05-.46L230.1 341a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35 0 .47l5.27 3a.87.87 0 0 0 .75.06Zm8.06-4.65 5.51-3.18c.23-.14.25-.34 0-.46l-5.27-3.05a.9.9 0 0 0-.8 0l-5.51 3.18c-.23.14-.26.35-.05.46l5.28 3a.87.87 0 0 0 .84.09Zm-26.28-.48-5.51 3.18c-.23.13-.26.34-.05.46l5.27 3a.92.92 0 0 0 .81 0l5.51-3.18c.23-.14.25-.35 0-.47l-5.27-3a.87.87 0 0 0-.76.05Zm8.06-4.65-5.52 3.18c-.23.13-.25.34 0 .46l5.27 3a.9.9 0 0 0 .8 0l5.51-3.19c.23-.13.26-.34.05-.46l-5.27-3a.87.87 0 0 0-.84.05Zm32.21-18.6-5.51 3.18c-.23.13-.25.34 0 .46l5.27 3a.9.9 0 0 0 .8 0l5.51-3.19c.23-.13.25-.34.05-.46l-5.28-3a.87.87 0 0 0-.84.05Zm-8.05 4.71-5.51 3.18c-.24.13-.26.34-.05.46l5.27 3a.9.9 0 0 0 .8 0l5.51-3.19c.24-.13.26-.34 0-.46l-5.27-3a.87.87 0 0 0-.75.01Zm16.11-9.31-5.51 3.19c-.24.13-.26.34 0 .46l5.27 3a.9.9 0 0 0 .8 0l5.51-3.19c.24-.13.26-.34.05-.46l-5.27-3a.9.9 0 0 0-.85-.02Zm-32.22 18.59-5.51 3.18c-.24.13-.26.34-.05.46l5.27 3a.9.9 0 0 0 .8 0l5.52-3.19c.23-.13.25-.34 0-.46l-5.27-3a.87.87 0 0 0-.76.01Zm8.05-4.65-5.51 3.18c-.23.13-.25.34 0 .46l5.27 3a.9.9 0 0 0 .8 0l5.51-3.19c.23-.13.26-.34.05-.46l-5.28-3a.87.87 0 0 0-.84.01Zm-10.28 30.28 5.51-3.18c.24-.13.26-.34.05-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35 0 .47l5.27 3a.87.87 0 0 0 .75-.01Zm-42.47-2-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35 0 .47l5.27 3a.87.87 0 0 0 .8 0l5.51-3.18c.19-.14.21-.38 0-.47Zm10.5 2.63-5.27-3a.87.87 0 0 0-.8 0l-8.43 4.88c-.24.14-.26.35 0 .47l5.27 3a.87.87 0 0 0 .8 0l8.48-4.89c.14-.13.16-.34-.05-.46Zm-18.37-8.64-5.27-3a.87.87 0 0 0-.8 0l-6.79 3.92c-.23.13-.25.34 0 .46l5.27 3a.9.9 0 0 0 .8 0l6.78-3.92c.2-.14.22-.36.01-.46Zm5.2-3a.87.87 0 0 0 .8 0l5.51-3.18c.24-.14.26-.35.05-.47l-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.24.13-.26.34-.05.46Zm22.82 14.78-5.27-3a.9.9 0 0 0-.8 0l-10.6 6.12c-.23.14-.26.34 0 .46l5.27 3a.89.89 0 0 0 .81 0l10.59-6.12c.19-.14.21-.35 0-.47Zm3.72 6.55-5.28-3a.9.9 0 0 0-.8 0l-6.79 3.89c-.23.14-.25.34 0 .46l5.28 3.05a.91.91 0 0 0 .8 0l6.78-3.92c.19-.16.22-.37.01-.49Zm33.35-55.9a.87.87 0 0 0 .8 0l5.51-3.18c.23-.14.25-.34.05-.46l-5.28-3a.91.91 0 0 0-.8 0l-5.5 3.12c-.23.14-.25.34-.05.46Zm-16.11 9.3a.87.87 0 0 0 .8 0l5.51-3.18c.23-.13.26-.34.05-.46l-5.28-3.05a.91.91 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.35 0 .47Zm-35.73 20.62a.92.92 0 0 0 .81 0l5.51-3.25c.23-.14.25-.35 0-.47l-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.23.13-.26.34 0 .46ZM232.16 318a.87.87 0 0 0 .8 0l5.51-3.18c.24-.13.26-.34.05-.46l-5.27-3.05a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35-.05.47Zm-16.11 9.3a.87.87 0 0 0 .8 0l5.51-3.18c.24-.13.26-.34 0-.46l-5.27-3.05a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35-.05.47Zm-5.23 42.28a.9.9 0 0 0-.8 0l-8.48 4.9c-.23.13-.25.34 0 .46l5.27 3a.87.87 0 0 0 .8 0l8.48-4.9c.23-.13.25-.34 0-.46Zm-6.33-35.61a.9.9 0 0 0 .8 0l5.52-3.19c.23-.13.25-.34 0-.46l-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.24.13-.26.34-.05.46Zm-8.05 4.65a.9.9 0 0 0 .8 0l5.51-3.19c.24-.13.26-.34.05-.46l-5.27-3a.87.87 0 0 0-.8 0l-5.52 3.18c-.23.13-.25.34 0 .46Zm163.61-55.2a.87.87 0 0 0-.8 0l-13.57 7.83c-.23.14-.26.34-.05.46l5.28 3.05a.87.87 0 0 0 .8 0l13.56-7.83c.24-.14.26-.34.05-.46Zm-17.81 10.28a.87.87 0 0 0-.8 0l-5.51 3.18c-.23.14-.26.34-.05.46l5.27 3.05a.89.89 0 0 0 .81 0l5.51-3.18c.23-.14.25-.34 0-.46Zm-108.71 60.56 5.51-3.18c.23-.13.25-.34.05-.46l-5.28-3a.9.9 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.35 0 .47l5.27 3a.87.87 0 0 0 .76-.01Zm92.6-51.26a.9.9 0 0 0-.8 0l-5.51 3.18c-.23.14-.26.34-.05.46l5.28 3.05a.87.87 0 0 0 .8 0l5.51-3.18c.23-.14.25-.34 0-.46Zm42-24.23a.87.87 0 0 0-.8 0l-5.54 3.23c-.23.14-.26.34-.05.46l5.27 3a.9.9 0 0 0 .8 0l5.52-3.18c.23-.14.25-.34 0-.46Zm13.33-1.6-12.81-7.4a.87.87 0 0 0-.8 0l-5.54 3.23c-.23.14-.25.34-.05.46l12.81 7.4a.9.9 0 0 0 .8 0l5.51-3.18c.23-.22.26-.42.05-.54ZM296 320.35a.87.87 0 0 0-.8 0l-6.78 3.91c-.23.14-.26.35-.05.47l5.27 3a.89.89 0 0 0 .81 0l6.78-3.91c.23-.14.25-.35.05-.47Zm20.35-11.75a.87.87 0 0 0-.8 0l-8.48 4.89c-.23.14-.25.35-.05.47l5.28 3a.87.87 0 0 0 .8 0l8.48-4.89c.23-.14.25-.34 0-.46Zm-39 22.52a.87.87 0 0 0-.8 0l-45.36 26.19c-.23.13-.26.34-.05.46l5.27 3a.87.87 0 0 0 .8 0l45.37-26.18c.23-.14.25-.35 0-.47Zm-47.9 27.66a.9.9 0 0 0-.8 0l-6.79 3.92c-.23.14-.25.34 0 .46l5.27 3.05a.9.9 0 0 0 .8 0l6.78-3.92c.23-.13.26-.34.05-.46Zm57.23-33a.87.87 0 0 0-.8 0l-6.79 3.92c-.23.13-.25.34 0 .46l5.27 3a.87.87 0 0 0 .8 0l6.78-3.92c.24-.13.26-.34.05-.46Zm-66.56 38.42a.87.87 0 0 0-.8 0l-6.78 3.91c-.24.14-.26.35 0 .47l5.27 3a.87.87 0 0 0 .8 0l6.78-3.91c.24-.14.26-.34 0-.46Zm85.24-49.2a.9.9 0 0 0-.8 0l-6.78 3.92c-.24.13-.26.34 0 .46l5.27 3.05a.9.9 0 0 0 .8 0l6.78-3.92c.24-.13.26-.34.05-.46Zm28.83-16.65a.87.87 0 0 0-.8 0l-5.52 3.18c-.23.14-.25.34 0 .46l5.23 3.01a.87.87 0 0 0 .8 0l5.51-3.18c.24-.14.26-.34 0-.46Zm18-12.59 5.51-3.18c.23-.14.26-.34.05-.46l-5.28-3a.91.91 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.34 0 .47l5.27 3a.87.87 0 0 0 .8-.04Zm-32.87 1.58 5.51-3.18c.23-.13.26-.34.05-.46l-5.27-3a.92.92 0 0 0-.81 0l-5.51 3.19c-.23.13-.25.34 0 .46l5.27 3a.87.87 0 0 0 .8-.04ZM298 317.06l16.1-9.3c.24-.14.26-.34.05-.46l-5.27-3.05a.9.9 0 0 0-.8 0l-16.11 9.3c-.23.14-.26.34-.05.46l5.27 3a.89.89 0 0 0 .81.05Zm45.4-26.65a.87.87 0 0 0 .8 0l5.51-3.18c.24-.14.26-.34.05-.46l-5.27-3.05a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35 0 .47Zm-6.76-4.41 5.51-3.18c.24-.13.26-.34.05-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35-.05.47l5.27 3a.87.87 0 0 0 .8-.01Zm-46.73 35.68 5.51-3.18c.24-.14.26-.34.05-.46L290.2 315a.87.87 0 0 0-.8 0l-5.52 3.18c-.23.14-.25.34 0 .46l5.27 3.05a.87.87 0 0 0 .76.02Zm35.66-21a.87.87 0 0 0 .8 0l5.51-3.18c.23-.14.25-.34.05-.46l-5.28-3a.91.91 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.34 0 .47ZM249.64 345l5.51-3.18c.23-.13.25-.34 0-.46l-5.28-3.05a.91.91 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.35-.05.47l5.28 3a.87.87 0 0 0 .85.04Zm8.05-4.65 5.51-3.18c.24-.13.26-.34.05-.46l-5.25-3.09a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35 0 .47l5.27 3a.87.87 0 0 0 .73.04Zm-16.11 9.3 5.51-3.18c.24-.13.26-.34 0-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.35-.05.47l5.27 3a.87.87 0 0 0 .85-.05ZM273.8 331l5.51-3.18c.24-.14.26-.34.05-.46l-5.27-3.05a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.34 0 .46L273 331a.87.87 0 0 0 .8 0Zm-8.05 4.65 5.51-3.18c.23-.13.25-.34.05-.46L266 329a.9.9 0 0 0-.8 0l-5.51 3.18c-.23.14-.25.35-.05.47l5.28 3a.87.87 0 0 0 .83.01Zm16.11-9.3 5.51-3.18c.23-.14.25-.34 0-.46l-5.27-3.05a.87.87 0 0 0-.8 0l-5.51 3.18c-.23.14-.26.34-.05.46l5.28 3.05a.87.87 0 0 0 .84.01Zm43.95-64.69a.87.87 0 0 0 .8 0l5.51-3.18c.24-.14.26-.34.05-.46l-1.4-.81a.9.9 0 0 0-.8 0l-5.52 3.19c-.23.13-.25.34 0 .46Zm-40 25.35a.91.91 0 0 0 .8 0l5.51-3.18c.23-.14.25-.35 0-.47l-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.23.13-.25.34-.05.46Zm16.11-9.3a.91.91 0 0 0 .8 0l5.51-3.18c.23-.14.25-.35 0-.47L303 271a.87.87 0 0 0-.8 0l-5.51 3.18c-.23.13-.26.34-.05.46Zm-25.95 15a.9.9 0 0 0 .8 0l5.51-3.19c.24-.13.26-.34.05-.46L277 286a.87.87 0 0 0-.8 0l-5.51 3.18c-.24.13-.26.34-.05.46Zm17.89-10.32a.9.9 0 0 0 .8 0l5.51-3.18c.24-.14.26-.35.05-.47l-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.24.13-.26.34-.05.46Zm-34 19.63a.94.94 0 0 0 .8 0l5.51-3.18c.24-.14.26-.35.05-.47l-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.24.13-.26.34-.05.46Zm8.06-4.66a.9.9 0 0 0 .8 0l5.51-3.18c.23-.14.25-.35 0-.47l-5.27-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.23.13-.25.34-.05.46ZM309.7 271a.87.87 0 0 0 .8 0l5.51-3.18c.24-.14.26-.34.05-.46l-1.4-.81a.9.9 0 0 0-.8 0l-5.51 3.19c-.24.13-.26.34-.05.46Zm24.17-14a.87.87 0 0 0 .8 0l5.51-3.18c.23-.14.25-.34 0-.46l-1.4-.81a.9.9 0 0 0-.8 0l-5.51 3.19c-.24.13-.26.34-.05.46Zm11.07 6.39a.9.9 0 0 0 .8 0l5.51-3.19c.24-.13.26-.34.05-.46l-5.27-3a.9.9 0 0 0-.8 0l-5.51 3.19c-.24.13-.26.34-.05.46Zm15.34 17.67 5.51-3.18c.24-.14.26-.34 0-.46l-5.27-3.05a.9.9 0 0 0-.8 0l-5.51 3.18c-.24.14-.26.34-.05.46l5.27 3.05a.87.87 0 0 0 .85.02Zm-42.52-14.76a.87.87 0 0 0 .8 0l5.51-3.18c.23-.14.25-.34 0-.46l-1.4-.81a.9.9 0 0 0-.8 0l-5.51 3.19c-.23.13-.26.34 0 .46Zm-66 40.33a.91.91 0 0 0 .8 0l5.51-3.18c.23-.14.25-.35.05-.47l-5.28-3a.87.87 0 0 0-.8 0l-5.51 3.18c-.23.13-.25.34-.05.46Z"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="m275.61 348.19 1.13.65 30.02 17.32 53.37-30.81 1.11-.64-31.14-17.97-54.49 31.45z"
      style={{
        fill: "#37474f",
      }}
    />
    <path
      d="m276.74 348.84 30.02 17.32 53.37-30.81-30.03-17.33-53.36 30.82z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="m107.06 213.2-12.23-7c-.54-.32-.94-.4-1.15-.27l-1.49.86c-.26.15-.25.59.07 1.27l3 6.16-2.22 2a1.73 1.73 0 0 0 .32 2.94l12.23 7.06 1.49-.87Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m107.06 213.2-12.23-7c-.54-.32-.94-.4-1.15-.27l-1.49.86c-.26.15-.25.59.07 1.27l3 6.16-2.22 2a1.73 1.73 0 0 0 .32 2.94l12.23 7.06 1.49-.87Z"
      style={{
        fill: "#fff",
        opacity: 0.5,
      }}
    />
    <path
      d="M93.34 207c-1.19-.69-1.68-.24-1.08 1l3 6.16-2.22 2a1.73 1.73 0 0 0 .32 2.94l12.23 7.06v-12.09Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M107 252.11a1.43 1.43 0 0 1-1.44-1.44v-40.62a1.44 1.44 0 0 1 2.87 0v40.62a1.43 1.43 0 0 1-1.43 1.44Z"
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="M54.39 360.27v-2.53H55a10 10 0 0 1 4.11-4c6.32-3.65 16.56-3.65 22.88 0a9.91 9.91 0 0 1 4.11 4h.62v2.45c0 2.43-1.52 4.87-4.73 6.72-6.32 3.65-16.56 3.65-22.88 0-3.11-1.83-4.74-4.24-4.72-6.64Z"
      style={{
        fill: "#263238",
      }}
    />
    <ellipse
      cx={70.56}
      cy={357.74}
      rx={16.18}
      ry={9.34}
      style={{
        fill: "#455a64",
      }}
    />
    <path
      d="M74.73 269.77v86.86a2.08 2.08 0 0 1-1.22 1.7 6.5 6.5 0 0 1-5.89 0 2.06 2.06 0 0 1-1.22-1.7v-86.86Z"
      style={{
        fill: "#37474f",
      }}
    />
    <path
      d="M66.4 280.28v8.17l8.33 4.8v-8.15l-8.33-4.82z"
      style={{
        fill: "#263238",
      }}
    />
    <path
      d="m96.6 262 15.4 8.9a1.15 1.15 0 0 1-.3.32l-26.94 15.55c-.23.13-.41 0-.41-.25v-19.41a30.35 30.35 0 0 1 2.25-10.88Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m96.6 262 15.4 8.9a1.15 1.15 0 0 1-.3.32l-26.94 15.55c-.23.13-.41 0-.41-.25v-19.41a30.35 30.35 0 0 1 2.25-10.88Z"
      style={{
        opacity: 0.4,
      }}
    />
    <path
      d="M112.12 249.25V271L86.6 256.24l.09-.21C89.42 249.19 94 243.4 99 240.52a11.68 11.68 0 0 1 5.77-1.79c4.54 0 7.35 4.03 7.35 10.52Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M112.12 249.25V271L86.6 256.24l.09-.21C89.42 249.19 94 243.4 99 240.52a11.68 11.68 0 0 1 5.77-1.79c4.54 0 7.35 4.03 7.35 10.52Z"
      style={{
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="M139.83 295.22v-1.94h-.19v.28a8.41 8.41 0 0 0-.5-1.57c-1-2.38-3.17-4.66-6.44-6.55l-18.23-10.53a3.09 3.09 0 0 0-2.75 0L83.84 291a4.28 4.28 0 0 1-.88-1v2a1 1 0 0 0 .56.8l18.24 10.52a34.74 34.74 0 0 0 17.43 4.12 30.21 30.21 0 0 0 14.51-3.53c4.1-2.35 6.12-5.48 6.12-8.67Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M139.83 295.22v-1.94h-.19v.28a8.41 8.41 0 0 0-.5-1.57c-1-2.38-3.17-4.66-6.44-6.55l-18.23-10.53a3.09 3.09 0 0 0-2.75 0L83.84 291a4.28 4.28 0 0 1-.88-1v2a1 1 0 0 0 .56.8l18.24 10.52a34.74 34.74 0 0 0 17.43 4.12 30.21 30.21 0 0 0 14.51-3.53c4.1-2.35 6.12-5.48 6.12-8.67Z"
      style={{
        opacity: 0.4,
      }}
    />
    <path
      d="M139.14 292c-1-2.38-3.17-4.66-6.44-6.55l-18.23-10.53a3.09 3.09 0 0 0-2.75 0L83.84 291l17.92 10.34a34.85 34.85 0 0 0 17.43 4.12 30.32 30.32 0 0 0 14.51-3.53c3.68-2.12 5.69-4.85 6.06-7.7a8.13 8.13 0 0 0-.62-2.23Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M139.14 292c-1-2.38-3.17-4.66-6.44-6.55l-18.23-10.53a3.09 3.09 0 0 0-2.75 0L83.84 291l17.92 10.34a34.85 34.85 0 0 0 17.43 4.12 30.32 30.32 0 0 0 14.51-3.53c3.68-2.12 5.69-4.85 6.06-7.7a8.13 8.13 0 0 0-.62-2.23Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="M139.76 294.24a8.13 8.13 0 0 0-.62-2.25c-1-2.38-3.17-4.66-6.44-6.55l-18.23-10.53a3.09 3.09 0 0 0-2.75 0L83.84 291l-.32-.18a.84.84 0 0 1 0-1.59l28.2-16.23a3 3 0 0 1 2.75 0l18.23 10.53c3.27 1.89 5.42 4.17 6.44 6.55a8.09 8.09 0 0 1 .64 2.39 7.3 7.3 0 0 1-.02 1.77Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M139.76 294.24a8.13 8.13 0 0 0-.62-2.25c-1-2.38-3.17-4.66-6.44-6.55l-18.23-10.53a3.09 3.09 0 0 0-2.75 0L83.84 291l-.32-.18a.84.84 0 0 1 0-1.59l28.2-16.23a3 3 0 0 1 2.75 0l18.23 10.53c3.27 1.89 5.42 4.17 6.44 6.55a8.09 8.09 0 0 1 .64 2.39 7.3 7.3 0 0 1-.02 1.77Z"
      style={{
        opacity: 0.30000000000000004,
      }}
    />
    <path
      d="m84.14 288.96 28.19-16.28-.63-1.47-26.94 15.56-.62 2.19z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m84.14 288.96 28.19-16.28-.63-1.47-26.94 15.56-.62 2.19z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="M109.63 248a1.47 1.47 0 0 0-.67-1.16L74.64 227a1.44 1.44 0 0 0-1.34 0l-.76.44a1.47 1.47 0 0 0-.67 1.16v26.31a1.49 1.49 0 0 0 .67 1.16l34.32 19.82a1.53 1.53 0 0 0 1.35 0l.75-.44a1.49 1.49 0 0 0 .67-1.16Z"
      style={{
        fill: "#f5f5f5",
      }}
    />
    <path
      d="m109.44 247.3-1.91 1.1-35.46-20.48a1.37 1.37 0 0 1 .47-.51l.76-.43a1.44 1.44 0 0 1 1.34 0L109 246.8a1.29 1.29 0 0 1 .44.5Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M107.38 276Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m107.54 248.39-.35.21a.58.58 0 0 1 .35.57v26.31a.46.46 0 0 1-.21.44.44.44 0 0 1-.32 0l-.14-.06-34.33-19.81a1.5 1.5 0 0 1-.67-1.16v-26.31a1.4 1.4 0 0 1 .2-.67Z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="m107.53 248.4-15.89 5.93a2.57 2.57 0 0 1-3.07-1L86 249.41l-14.06-21.57 13.57 21.72-13.64 5.34a1.32 1.32 0 0 0 .21.67l13.47-5.95 3 4.75a2.59 2.59 0 0 0 3.24 1l2.11-.93 13.47 21.49a.48.48 0 0 0 .2-.44V275l-13.64-20.6Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="M101.51 252.61a1.5 1.5 0 0 0-.67-1.16l-34.33-19.81a1.44 1.44 0 0 0-1.34 0l-.76.43a1.5 1.5 0 0 0-.67 1.16v26.31a1.53 1.53 0 0 0 .67 1.17l34.33 19.81a1.44 1.44 0 0 0 1.34 0l.76-.43a1.5 1.5 0 0 0 .67-1.16Z"
      style={{
        fill: "#f5f5f5",
      }}
    />
    <path
      d="m101.31 252-1.9 1.1-35.47-20.53a1.42 1.42 0 0 1 .47-.5l.76-.43a1.44 1.44 0 0 1 1.34 0l34.33 19.81a1.42 1.42 0 0 1 .47.55Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M99.25 280.67Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m99.41 253.05-.35.21a.58.58 0 0 1 .35.57v26.31a.46.46 0 0 1-.21.44.44.44 0 0 1-.32 0l-.14-.06-34.33-19.81a1.5 1.5 0 0 1-.67-1.16v-26.31a1.4 1.4 0 0 1 .2-.67Z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="M99.41 253.05 83.51 259a2.58 2.58 0 0 1-3.06-1l-2.56-3.91-14.08-21.59 13.57 21.72-13.64 5.34a1.63 1.63 0 0 0 .21.67l13.47-6 3 4.75a2.59 2.59 0 0 0 3.23 1l2.12-.93 13.43 21.53a.46.46 0 0 0 .21-.44v-.44L85.8 259.06Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="M93.38 257.27a1.47 1.47 0 0 0-.67-1.16l-34.32-19.82a1.5 1.5 0 0 0-1.34 0l-.76.44a1.47 1.47 0 0 0-.67 1.16v26.31a1.47 1.47 0 0 0 .67 1.16l34.32 19.82a1.53 1.53 0 0 0 1.35 0l.75-.44a1.47 1.47 0 0 0 .67-1.16Z"
      style={{
        fill: "#f5f5f5",
      }}
    />
    <path
      d="m93.19 256.61-1.91 1.1-35.46-20.48a1.34 1.34 0 0 1 .47-.5l.76-.44a1.5 1.5 0 0 1 1.34 0l34.32 19.82a1.36 1.36 0 0 1 .48.5Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M91.13 285.32a.27.27 0 0 0 .13 0 .13.13 0 0 1-.13 0Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m91.29 257.7-.35.21a.58.58 0 0 1 .35.57v26.32a.45.45 0 0 1-.21.43.44.44 0 0 1-.32 0l-.14-.05-34.33-19.82a1.47 1.47 0 0 1-.67-1.16v-26.3a1.4 1.4 0 0 1 .2-.67Z"
      style={{
        fill: "#ebebeb",
      }}
    />
    <path
      d="m91.28 257.71-15.89 5.94a2.59 2.59 0 0 1-3.07-1l-2.55-3.91-14.08-21.58 13.57 21.71-13.64 5.34a1.32 1.32 0 0 0 .21.67l13.47-5.95 3 4.75a2.59 2.59 0 0 0 3.24 1l2.11-.94 13.47 21.49a.46.46 0 0 0 .2-.44v-.44l-13.6-20.64Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="M108.55 238c-2.73-1.43-6.35-1.18-10.31 1.12-4.45 2.55-8.46 7.19-11.27 12.5a39.35 39.35 0 0 0-1.76 3.79 31.89 31.89 0 0 0-2.45 11.67v22.22a2.89 2.89 0 0 1-1.37-.33L41.9 266.15a3.07 3.07 0 0 1-1.37-2.38v-21.06c0-10.52 6.93-23 15.47-28 4-2.34 7.73-2.53 10.49-1Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M108.55 238c-2.73-1.43-6.35-1.18-10.31 1.12-4.45 2.55-8.46 7.19-11.27 12.5a39.35 39.35 0 0 0-1.76 3.79 31.89 31.89 0 0 0-2.45 11.67v22.22a2.89 2.89 0 0 1-1.37-.33L41.9 266.15a3.07 3.07 0 0 1-1.37-2.38v-21.06c0-10.52 6.93-23 15.47-28 4-2.34 7.73-2.53 10.49-1Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="M41.9 266.15 81.39 289a2.89 2.89 0 0 0 1.37.33v-22.22a28.06 28.06 0 0 1 .74-6.21l-42.24-24.39a28.55 28.55 0 0 0-.73 6.2v21.06a3.07 3.07 0 0 0 1.37 2.38Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="M85.21 255.44a31.89 31.89 0 0 0-2.45 11.67v22.19a2.73 2.73 0 0 1-.5-.06v-22.13c0-16.31 12.55-26.68 16-28-4.45 2.55-8.46 7.19-11.27 12.5a39.35 39.35 0 0 0-1.78 3.83Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M85.21 255.44a31.89 31.89 0 0 0-2.45 11.67v22.19a2.73 2.73 0 0 1-.5-.06v-22.13c0-16.31 12.55-26.68 16-28-4.45 2.55-8.46 7.19-11.27 12.5a39.35 39.35 0 0 0-1.78 3.83Z"
      style={{
        opacity: 0.4,
      }}
    />
    <path
      d="M84.76 286.77c-.22.13-.41 0-.41-.24v-19.41a30.26 30.26 0 0 1 2.25-10.88l.09-.21a36.55 36.55 0 0 1 1.88-4C91.3 247 95 242.82 99 240.52a11.68 11.68 0 0 1 5.77-1.79 6.33 6.33 0 0 1 3 .73c2.7 1.44 4.28 4.92 4.28 9.79v21.25a.92.92 0 0 1-.41.71l.62 1.47.14-.08a3 3 0 0 0 .57-.55 3 3 0 0 0 .66-1.74v-21.06c0-5.63-2-9.55-5.15-11.21-2.73-1.44-6.35-1.19-10.31 1.11-4.45 2.55-8.46 7.18-11.27 12.51a39.35 39.35 0 0 0-1.76 3.78 31.86 31.86 0 0 0-2.45 11.68v22.17H83a2.75 2.75 0 0 0 1.14-.32Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M84.76 286.77c-.22.13-.41 0-.41-.24v-19.41a30.26 30.26 0 0 1 2.25-10.88l.09-.21a36.55 36.55 0 0 1 1.88-4C91.3 247 95 242.82 99 240.52a11.68 11.68 0 0 1 5.77-1.79 6.33 6.33 0 0 1 3 .73c2.7 1.44 4.28 4.92 4.28 9.79v21.25a.92.92 0 0 1-.41.71l.62 1.47.14-.08a3 3 0 0 0 .57-.55 3 3 0 0 0 .66-1.74v-21.06c0-5.63-2-9.55-5.15-11.21-2.73-1.44-6.35-1.19-10.31 1.11-4.45 2.55-8.46 7.18-11.27 12.51a39.35 39.35 0 0 0-1.76 3.78 31.86 31.86 0 0 0-2.45 11.68v22.17H83a2.75 2.75 0 0 0 1.14-.32Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="M178.94 229.88a5.71 5.71 0 0 1 2.6-4.5l128.17-74a5.74 5.74 0 0 1 5.2 0l2.93 1.69a5.74 5.74 0 0 1 2.59 4.5v101.88a5.77 5.77 0 0 1-2.59 4.5L189.66 338a5.78 5.78 0 0 1-5.19 0l-2.93-1.69a5.77 5.77 0 0 1-2.6-4.5Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <g
      style={{
        opacity: 0.7000000000000001,
      }}
    >
      <path
        d="M178.94 229.88a5.71 5.71 0 0 1 2.6-4.5l128.17-74a5.74 5.74 0 0 1 5.2 0l2.93 1.69a5.74 5.74 0 0 1 2.59 4.5v101.88a5.77 5.77 0 0 1-2.59 4.5L189.66 338a5.78 5.78 0 0 1-5.19 0l-2.93-1.69a5.77 5.77 0 0 1-2.6-4.5Z"
        style={{
          fill: "#fff",
        }}
      />
    </g>
    <path
      d="m179.7 227.32 7.37 4.25L319.67 155a5.44 5.44 0 0 0-1.83-1.94l-2.94-1.68a5.64 5.64 0 0 0-5.18 0l-128.18 74a5.22 5.22 0 0 0-1.84 1.94Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m179.7 227.32 7.37 4.25L319.67 155a5.44 5.44 0 0 0-1.83-1.94l-2.94-1.68a5.64 5.64 0 0 0-5.18 0l-128.18 74a5.22 5.22 0 0 0-1.84 1.94Z"
      style={{
        fill: "#fff",
        opacity: 0.8,
      }}
    />
    <path
      d="M178.94 229.87v101.88a5.71 5.71 0 0 0 2.6 4.5l2.93 1.7a4.62 4.62 0 0 0 .71.32 5.78 5.78 0 0 0 1.07.24 6.41 6.41 0 0 0 2.05-.07l.51-.13.32-.11a1.55 1.55 0 0 1-1.26-.05 1.78 1.78 0 0 1-.8-1.7V234.57a2.27 2.27 0 0 1 1.35-2.21l-1.35-.79-7.37-4.25a5.29 5.29 0 0 0-.76 2.55Z"
      style={{
        fill: "#ffc100",
        opacity: 0.1,
      }}
    />
    <path
      d="M178.94 229.87v101.88a5.71 5.71 0 0 0 2.6 4.5l2.93 1.7a4.62 4.62 0 0 0 .71.32 5.78 5.78 0 0 0 1.07.24 6.41 6.41 0 0 0 2.05-.07l.51-.13.32-.11a1.55 1.55 0 0 1-1.26-.05 1.78 1.78 0 0 1-.8-1.7V234.57a2.27 2.27 0 0 1 1.35-2.21l-1.35-.79-7.37-4.25a5.29 5.29 0 0 0-.76 2.55Z"
      style={{
        opacity: 0.05,
      }}
    />
    <path
      d="m187.07 231.57 61.55 23a10 10 0 0 0 11.88-3.91l9.88-15.15L319.67 155l-47.32 81.07 48.08 23.41a5.44 5.44 0 0 1-.81 2.6l-47.42-25.76-11.48 18.38a10 10 0 0 1-12.53 3.85l-8.19-3.61-52.15 83.21a1.78 1.78 0 0 1-.8-1.7v-1.7l52.69-79.92Z"
      style={{
        fill: "#ffc100",
        opacity: 0.2,
      }}
    />
    <path
      d="m187.07 231.57 61.55 23a10 10 0 0 0 11.88-3.91l9.88-15.15L319.67 155l-47.32 81.07 48.08 23.41a5.44 5.44 0 0 1-.81 2.6l-47.42-25.76-11.48 18.38a10 10 0 0 1-12.53 3.85l-8.19-3.61-52.15 83.21a1.78 1.78 0 0 1-.8-1.7v-1.7l52.69-79.92Z"
      style={{
        opacity: 0.05,
      }}
    />
    <path
      d="M211.44 248.66a5.74 5.74 0 0 1 2.59-4.5l128.18-74a5.72 5.72 0 0 1 5.19 0l2.93 1.69a5.74 5.74 0 0 1 2.6 4.5v101.88a5.76 5.76 0 0 1-2.6 4.5l-128.17 74a5.8 5.8 0 0 1-5.2 0L214 355a5.79 5.79 0 0 1-2.59-4.5Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <g
      style={{
        opacity: 0.5,
      }}
    >
      <path
        d="M211.44 248.66a5.74 5.74 0 0 1 2.59-4.5l128.18-74a5.72 5.72 0 0 1 5.19 0l2.93 1.69a5.74 5.74 0 0 1 2.6 4.5v101.88a5.76 5.76 0 0 1-2.6 4.5l-128.17 74a5.8 5.8 0 0 1-5.2 0L214 355a5.79 5.79 0 0 1-2.59-4.5Z"
        style={{
          fill: "#fff",
        }}
      />
    </g>
    <path
      d="m212.19 246.1 7.38 4.25 132.6-76.56a5.44 5.44 0 0 0-1.83-1.94l-2.94-1.68a5.66 5.66 0 0 0-5.19 0L214 244.16a5.24 5.24 0 0 0-1.81 1.94Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m212.19 246.1 7.38 4.25 132.6-76.56a5.44 5.44 0 0 0-1.83-1.94l-2.94-1.68a5.66 5.66 0 0 0-5.19 0L214 244.16a5.24 5.24 0 0 0-1.81 1.94Z"
      style={{
        fill: "#fff",
        opacity: 0.6000000000000001,
      }}
    />
    <path
      d="M211.43 248.65v101.88A5.72 5.72 0 0 0 214 355l2.92 1.7a4.75 4.75 0 0 0 .72.32 5.6 5.6 0 0 0 1.07.24 6.42 6.42 0 0 0 2.05-.07l.5-.14a1.66 1.66 0 0 0 .31-.12 1.55 1.55 0 0 1-1.24 0 1.81 1.81 0 0 1-.8-1.71V253.35a2.27 2.27 0 0 1 1.35-2.21l-1.35-.79-7.38-4.25a5.4 5.4 0 0 0-.72 2.55Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="m219.57 250.35 61.55 23a10 10 0 0 0 11.88-3.91l9.89-15.14 49.29-80.51-47.32 81.07 48.08 23.41a5.44 5.44 0 0 1-.81 2.6L304.7 255.1l-11.49 18.38a10 10 0 0 1-12.52 3.85l-8.18-3.61-52.14 83.22a1.81 1.81 0 0 1-.8-1.71v-1.7l52.69-79.92Z"
      style={{
        fill: "#ffc100",
        opacity: 0.4,
      }}
    />
    <path
      d="m219.57 250.35 61.55 23a10 10 0 0 0 11.88-3.91l9.89-15.14 49.29-80.51-47.32 81.07 48.08 23.41a5.44 5.44 0 0 1-.81 2.6L304.7 255.1l-11.49 18.38a10 10 0 0 1-12.52 3.85l-8.18-3.61-52.14 83.22a1.81 1.81 0 0 1-.8-1.71v-1.7l52.69-79.92Z"
      style={{
        opacity: 0.05,
      }}
    />
    <path
      d="m244.2 268.26 133.38-77 5.34 3.08a5.57 5.57 0 0 1 2.51 4.34v98.4a5.55 5.55 0 0 1-2.51 4.34l-128.36 74.1a5.55 5.55 0 0 1-5 0l-2.83-1.63a5.57 5.57 0 0 1-2.51-4.34Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m244.2 268.26 133.38-77 5.34 3.08a5.57 5.57 0 0 1 2.51 4.34v98.4a5.55 5.55 0 0 1-2.51 4.34l-128.36 74.1a5.55 5.55 0 0 1-5 0l-2.83-1.63a5.57 5.57 0 0 1-2.51-4.34Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="m376.85 182.6.54-.3-2.07-1.2a3.06 3.06 0 0 0-.55-.26l-58.7-21.76a4.05 4.05 0 0 0-4.51 1.44l-65.66 95.89a11.34 11.34 0 0 0-1.7 5.48v6.36l2 1.19 131.34-78.19v-6.37a4.3 4.3 0 0 0-.69-2.28Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M314.28 161a3.32 3.32 0 0 0-.68.72l-65.67 95.89a10.2 10.2 0 0 0-1.22 2.74l-2-1.18a13.1 13.1 0 0 1 .53-1.45c.09-.2.18-.39.28-.58l.05-.09a5.23 5.23 0 0 1 .35-.58l65.66-95.89a3.19 3.19 0 0 1 .33-.4l.35-.32Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="M377.37 182.29a3.2 3.2 0 0 0-.56-.27l-58.71-21.76a4 4 0 0 0-3.82.72l-2-1.18a4.07 4.07 0 0 1 3.83-.72l58.7 21.75a3.11 3.11 0 0 1 .55.27Z"
      style={{
        fill: "#fff",
        opacity: 0.35000000000000003,
      }}
    />
    <path
      d="M245.55 257a6.36 6.36 0 0 1 .35-.58 6.36 6.36 0 0 0-.35.58ZM311.89 160.12l.35-.32ZM244.67 259.15a13.1 13.1 0 0 1 .53-1.45 13.1 13.1 0 0 0-.53 1.45ZM245.22 257.66Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M245.2 257.7ZM244.67 259.15zM312.24 159.8zM245.5 257.08a.41.41 0 0 1 .05-.09.41.41 0 0 0-.05.09ZM311.56 160.52a4.12 4.12 0 0 1 .33-.4 2.6 2.6 0 0 0-.33.4Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="m313.6 161.7-65.67 95.89a11.44 11.44 0 0 0-1.69 5.48v6.37l133.38-77v-6.36a4.62 4.62 0 0 0-2.81-4l-58.71-21.81a4 4 0 0 0-4.5 1.43Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M379.62 186.06a4.35 4.35 0 0 0-.71-2.24l-132.2 76.51a9.8 9.8 0 0 0-.46 2.72v6.37l133.38-77Z"
      style={{
        opacity: 0.05,
      }}
    />
    <path
      d="M373.92 159a1.55 1.55 0 0 0-.62-1.4l-4.08-2.35a1.53 1.53 0 0 0-1.53.16l-109.4 63.19a4.78 4.78 0 0 0-2.17 3.75v131a1.51 1.51 0 0 0 .63 1.4l4.06 2.35a1.55 1.55 0 0 0 1.53-.15l109.42-63.15a4.8 4.8 0 0 0 2.16-3.75Z"
      style={{
        fill: "#f0f0f0",
      }}
    />
    <path
      d="m262.35 357 109.41-63.2a4.8 4.8 0 0 0 2.16-3.75V159c0-1.38-1-1.94-2.16-1.25l-109.41 63.19a4.8 4.8 0 0 0-2.16 3.75v131c0 1.41.97 1.97 2.16 1.31Z"
      style={{
        fill: "#fafafa",
      }}
    />
    <path
      d="M332.47 233a19.26 19.26 0 0 1-.82 4.36 18.59 18.59 0 0 1-1.58 3.66 14 14 0 0 1-2.06 2.8 8.79 8.79 0 0 1-2.29 1.75 4.8 4.8 0 0 1-3.15.76 2.81 2.81 0 0 1-1.63-1q-.36.78-.75 1.56a9.3 9.3 0 0 1-1 1.57 9.42 9.42 0 0 1-1.47 1.51 11.11 11.11 0 0 1-2.15 1.4 4.18 4.18 0 0 1-2.72.54 3.2 3.2 0 0 1-2-1.41 8.23 8.23 0 0 1-1.21-3.18 21.88 21.88 0 0 1-.27-4.78 30.89 30.89 0 0 1 .65-5.24 25.09 25.09 0 0 1 1.43-4.53 15 15 0 0 1 2.14-3.56 8.75 8.75 0 0 1 2.77-2.3 3.23 3.23 0 0 1 2.48-.53 2.71 2.71 0 0 1 1.28 1.19v-.54a3 3 0 0 1 .37-1.3 2.08 2.08 0 0 1 .8-.89l2.14-1.09a.6.6 0 0 1 .76.08 1.3 1.3 0 0 1 .29 1l-.48 12.71q-.06 1.44.54 1.89a1.26 1.26 0 0 0 1.43 0 3.57 3.57 0 0 0 1.45-1.54 7.46 7.46 0 0 0 .79-3.08c.1-1.11.17-2.25.22-3.43s.05-2.27 0-3.27a19.81 19.81 0 0 0-.8-5.3 5.75 5.75 0 0 0-2-3.07 4.67 4.67 0 0 0-3.35-.73 14.84 14.84 0 0 0-4.88 1.67 17.1 17.1 0 0 0-4.32 3.18 22.69 22.69 0 0 0-3.36 4.42 27.15 27.15 0 0 0-2.34 5.35 32.19 32.19 0 0 0-1.29 5.9c-.07.55-.13 1.25-.18 2.12s-.09 1.77-.13 2.71-.07 1.85-.09 2.73 0 1.57 0 2.1a15.92 15.92 0 0 0 .86 4.74 6.89 6.89 0 0 0 2 3.06 4.78 4.78 0 0 0 3.14 1.1 9.22 9.22 0 0 0 4.23-1.19 25.22 25.22 0 0 0 2.93-1.74 19.77 19.77 0 0 0 2.19-1.76 21 21 0 0 0 1.62-1.74c.45-.57.86-1.12 1.23-1.66s.56-.83.75-1.06a2 2 0 0 1 .73-.58l3-1.56a.65.65 0 0 1 .78 0c.22.18.31.53.26 1.07a2.46 2.46 0 0 1-.32 1c-.61 1.13-1.3 2.33-2.06 3.58a27.23 27.23 0 0 1-2.7 3.68 30.55 30.55 0 0 1-3.69 3.53 28.12 28.12 0 0 1-5 3.2 12.64 12.64 0 0 1-6.23 1.69 6.82 6.82 0 0 1-4.42-1.8 10.41 10.41 0 0 1-2.69-4.56 23.09 23.09 0 0 1-1-6.57v-2.22c0-.93.05-1.91.09-2.93s.09-2 .14-2.92.1-1.66.15-2.19a40 40 0 0 1 1.54-7.82 37.91 37.91 0 0 1 3.18-7.6 32.6 32.6 0 0 1 4.8-6.6 22.9 22.9 0 0 1 6.37-4.82 16.28 16.28 0 0 1 7.05-2.14 6.64 6.64 0 0 1 4.63 1.63 9.3 9.3 0 0 1 2.55 4.64 29.67 29.67 0 0 1 .88 6.85c0 1 0 2.21-.07 3.59s-.05 2.76-.14 3.91Zm-18.78 7.32a8 8 0 0 0 .6 4.16c.47.82 1.19 1 2.15.49a5.14 5.14 0 0 0 2.35-2.76 14.58 14.58 0 0 0 .94-5 8.44 8.44 0 0 0-.58-4.2c-.46-.84-1.2-1-2.21-.48a5.15 5.15 0 0 0-2.29 2.78 14.81 14.81 0 0 0-.96 4.97Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M260.18 355.72a1.63 1.63 0 0 0 .51 1.32l-3.93-2.26a1.51 1.51 0 0 1-.64-1.4v-131a4.34 4.34 0 0 1 .64-2.13l4.06 2.34a4.37 4.37 0 0 0-.64 2.14Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
    <path
      d="M382.05 298.38a1.21 1.21 0 0 1-.14.2L326.32 281a9.58 9.58 0 0 0-12 3.7L254.89 373l-2.2 1.27a1.79 1.79 0 0 1-1.7.19l61.11-91a9.62 9.62 0 0 1 12-3.71Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m308.84 293.32.14-.12-54.09 79.8-2.2 1.27a1.82 1.82 0 0 1-1.7.19L306.7 292ZM382.05 298.38a1.21 1.21 0 0 1-.14.2L326.32 281a9.57 9.57 0 0 0-12 3.7l-2.2-1.28a9.6 9.6 0 0 1 12-3.68Z"
      style={{
        fill: "#fff",
        opacity: 0.4,
      }}
    />
    <path
      d="M385.38 198.05c-.12-.72-.5-.92-1-.58a2.89 2.89 0 0 0-.64.66l-.28.39-54.85 83.38-8.19 11.41a4.67 4.67 0 0 1-4.51 1.69l-7.07-1.68-54-19.86a2.75 2.75 0 0 0-1.1 0 2 2 0 0 0-.41.13l2-1.18 51.74 19 6.81 2.43a4.65 4.65 0 0 0 4.51-1.69l8.19-11.4 55.12-83.77a2.2 2.2 0 0 1 .62-.57l-4.77-2.75 2-1.15 3.3 1.9a5.72 5.72 0 0 1 2.53 3.64Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m328.61 281.9-8.19 11.41a4.67 4.67 0 0 1-4.51 1.69l-7.07-1.68.14-.12.34-.54 4.63 1.1a4.65 4.65 0 0 0 4.51-1.69l8.11-11.28Z"
      style={{
        fill: "#fff",
        opacity: 0.4,
      }}
    />
    <path
      d="m382.92 194.32-3.3-1.9-2 1.15 4.77 2.75a2.1 2.1 0 0 0-.62.57l-55.12 83.77-.08.11 2 1.11 54.85-83.39.28-.39a2.89 2.89 0 0 1 .64-.66c.49-.34.87-.14 1 .58a5.72 5.72 0 0 0-2.42-3.7Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="m256 275.05-11.77-6.79v101.29a5.57 5.57 0 0 0 2.51 4.34l2.83 1.63a5.55 5.55 0 0 0 5 0l1.41-.81Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m256 275.05-11.77-6.79v101.29a5.57 5.57 0 0 0 2.51 4.34l2.83 1.63a5.55 5.55 0 0 0 5 0l1.41-.81Z"
      style={{
        opacity: 0.15,
      }}
    />
    <path
      d="M385.43 198.68v98.39a5.11 5.11 0 0 1-.78 2.54 5.48 5.48 0 0 1-1.47 1.65l-.1.05a1.53 1.53 0 0 1-.16.11l-128.36 74.1a1.79 1.79 0 0 1-1.71.2 1.52 1.52 0 0 1-.75-1.2 3.19 3.19 0 0 1 0-.45v-98.4a2.18 2.18 0 0 1 2.82-2.22l54 19.86 7.07 1.68a4.67 4.67 0 0 0 4.51-1.69l8.19-11.41 54.85-83.38.28-.39c.85-1.28 1.61-1.04 1.61.56Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m382.92 301.42.17-.11.09-.06a5.32 5.32 0 0 0 1.47-1.64 5.11 5.11 0 0 0 .78-2.5l-56.81-15.2 38 28.89Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m382.92 301.42.17-.11.09-.06a5.32 5.32 0 0 0 1.47-1.64 5.11 5.11 0 0 0 .78-2.5l-56.81-15.2 38 28.89Z"
      style={{
        opacity: 0.2,
      }}
    />
    <path
      d="M252.05 374.07a1.73 1.73 0 0 0 .78 1.65 1.78 1.78 0 0 0 1.71-.19L298.75 350l10.1-56.69-56.8 79.12Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m314.29 284.64-61.46 91.08a1.73 1.73 0 0 1-.78-1.65v-1.63l60-89Z"
      style={{
        opacity: 0.15,
      }}
    />
    <path
      d="M384.65 299.61a5.32 5.32 0 0 1-1.47 1.64l-.09.06-128.53 74.21a1.78 1.78 0 0 1-1.71.19l61.47-91.09a9.65 9.65 0 0 1 12.08-3.71Z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m244.67 259.15 2 1.18a10 10 0 0 0-.47 2.74v6.36l-2-1.18v-6.37a10 10 0 0 1 .47-2.73Z"
      style={{
        opacity: 0.15,
      }}
    />
    <path
      d="m255.4 272.37-2.04 1.18-2.06-1.19-5.07-2.92 1.97-1.17 7.2 4.1z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="m255.49 272.41-7.29-4.14-2 1.17 5.07 2.92 2.06 1.19.39-.12a2.75 2.75 0 0 1 1.1 0L259 275l47.11 17.35.74-1.09Z"
      style={{
        opacity: 0.1,
      }}
    />
    <path
      d="m145 102.07-7.62 4.4a8.68 8.68 0 0 0 .06-1v-2.2c0-3.93-2.76-5.52-6.16-3.56a12.15 12.15 0 0 0-3.67 3.53c-.55-4.94-4.43-6.78-9.14-4.06-5.08 2.94-9.21 10.08-9.21 16v3.3a8.73 8.73 0 0 0 .78 3.83l-6.33 3.65a7.57 7.57 0 0 0-3.41 5.92c0 2.18 1.53 3.06 3.41 2L145 110a7.55 7.55 0 0 0 3.41-5.91c.03-2.22-1.5-3.09-3.41-2.02ZM108.14 77l-9.38 5.41a10.46 10.46 0 0 0 .08-1.24v-2.76c0-4.83-3.39-6.79-7.58-4.37a14.75 14.75 0 0 0-4.52 4.34c-.68-6.08-5.45-8.34-11.25-5C69.23 77 64.15 85.8 64.15 93v4.06a10.72 10.72 0 0 0 1 4.71l-7.79 4.5a9.3 9.3 0 0 0-4.21 7.28c0 2.69 1.89 3.77 4.21 2.43l50.82-29.34a9.27 9.27 0 0 0 4.21-7.28c-.04-2.66-1.92-3.74-4.25-2.36Z"
      style={{
        fill: "#f0f0f0",
      }}
    />
    <path
      d="m404.96 164.72 35.37-22.65 15.59 5-50.96 17.65zM404.96 164.72l30.57-25.5-6.79-7.84-23.78 33.34z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M435.53 139.22v5.92l-30.57 19.58 30.57-25.5z"
      style={{
        fill: "#ffc100",
      }}
    />
    <path
      d="M435.53 139.22v5.92l-30.57 19.58 30.57-25.5z"
      style={{
        opacity: 0.25,
      }}
    />
    <path
      d="M440.63 138.73a.75.75 0 0 1-.51-1.3 26.07 26.07 0 0 0 2.89-3.15.75.75 0 1 1 1.19.91 27.61 27.61 0 0 1-3.06 3.34.78.78 0 0 1-.51.2Zm5.63-7.47a.71.71 0 0 1-.34-.08.74.74 0 0 1-.33-1 25.52 25.52 0 0 0 2-5.47.75.75 0 0 1 1.46.35 26.38 26.38 0 0 1-2.1 5.79.75.75 0 0 1-.69.41Zm2.74-10.57a.75.75 0 0 1-.72-.78v-1.21a27.59 27.59 0 0 0-.39-4.61.75.75 0 0 1 .61-.87.76.76 0 0 1 .87.62 29.52 29.52 0 0 1 .41 4.86v1.27a.75.75 0 0 1-.78.72Zm-1.61-10.81a.75.75 0 0 1-.71-.51 32.12 32.12 0 0 0-2.43-5.32.77.77 0 0 1 .28-1 .76.76 0 0 1 1 .28 33.15 33.15 0 0 1 2.53 5.58.75.75 0 0 1-.46 1 1 1 0 0 1-.22-.03Zm-5.26-9.61a.75.75 0 0 1-.59-.29 38.31 38.31 0 0 0-3.94-4.36.75.75 0 1 1 1-1.09 40.42 40.42 0 0 1 4.1 4.53.75.75 0 0 1-.14 1 .74.74 0 0 1-.44.21Zm-7.83-7.68a.74.74 0 0 1-.45-.15 48.3 48.3 0 0 0-4.93-3.25.76.76 0 0 1-.27-1 .74.74 0 0 1 1-.27 49.58 49.58 0 0 1 5.08 3.35.75.75 0 0 1-.45 1.35Zm-78.59-2.9a.75.75 0 0 1-.38-1.4c1.74-1 3.54-1.94 5.37-2.81a.75.75 0 0 1 1 .36.74.74 0 0 1-.36 1c-1.79.85-3.56 1.77-5.26 2.75a.74.74 0 0 1-.38.1ZM424.87 87a.71.71 0 0 1-.32-.07c-1.78-.86-3.61-1.65-5.45-2.36a.75.75 0 0 1-.43-1 .75.75 0 0 1 1-.43c1.87.72 3.74 1.53 5.56 2.41a.75.75 0 0 1-.33 1.42Zm-59.27-2a.77.77 0 0 1-.7-.48.75.75 0 0 1 .43-1c1.87-.73 3.8-1.4 5.73-2a.75.75 0 0 1 .43 1.44 72.74 72.74 0 0 0-5.61 1.93.71.71 0 0 1-.28.05Zm49-2a.57.57 0 0 1-.22 0 74.34 74.34 0 0 0-5.74-1.49A.75.75 0 1 1 409 80c2 .43 3.94.94 5.86 1.53a.75.75 0 0 1 .5.94.76.76 0 0 1-.72.53Zm-38.5-1.31a.75.75 0 0 1-.73-.58.76.76 0 0 1 .57-.9c1.95-.45 3.95-.83 5.95-1.12a.75.75 0 1 1 .22 1.48c-2 .29-3.92.66-5.84 1.11Zm27.82-1.15h-.11c-1.95-.29-3.94-.5-5.91-.63a.75.75 0 1 1 .1-1.49c2 .13 4 .34 6 .63a.75.75 0 0 1-.11 1.49ZM387 80a.75.75 0 0 1-.06-1.5c2-.16 4.05-.25 6.06-.25a.75.75 0 0 1 0 1.5c-2 0-4 .09-5.94.25Z"
      style={{
        fill: "#e0e0e0",
      }}
    />
  </svg>
)
export default React.memo(EmailIllustration);
